/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryAddressCheckResponseSchema = z.object({
	is_allowed: z.boolean(),
	delivery_cost: z.number().nullable().describe("Стоимость доставки по адресу; оплачивается вместе с заказом. Пусто — бесплатно."),
	error_code: z.int().nullable(),
	message: z.string().nullable().describe("Причина отказа для гостя."),
	zone: z.string().nullable(),
	duration_minutes: z.int().nullable(),
	min_sum: z.number().nullable(),
	latitude: z.number().nullable(),
	longitude: z.number().nullable(),
});
